import { Navigate, Route, Routes } from "react-router-dom";
import { Layout, Spin } from "antd";
import { ErrorAlert } from "@gull/ui";
import { useEmbedSession, type EmbedSession } from "./lib/useEmbedSession";
import EmbedBestillPose from "./pages/embed/EmbedBestillPose";

const { Content } = Layout;

function expiredCopy(session: Extract<EmbedSession, { status: "expired" }>) {
  if (session.serverError) {
    return { title: "Innlogging fra Min side er ikke tilgjengelig", description: session.message };
  }
  // A session TRY signed, but for a customer we cannot confirm or who did not log in with Vipps, is
  // not an expired one: the server's message says what to do.
  if (session.code === "EMBED_CUSTOMER_UNKNOWN" || session.code === "EMBED_VIPPS_REQUIRED") {
    return { title: session.message };
  }
  return { title: "Økten er utløpt", description: "Gå tilbake til Min side og prøv igjen." };
}

/**
 * The root TRY frames. It has no header, no login of its own and no route out of the frame: the
 * session comes from the host page, and a customer who has none is told to go back to Min side.
 */
export default function EmbedApp() {
  const session = useEmbedSession();

  if (session.status === "pending") {
    return (
      <Content style={{ padding: 48 }}>
        <Spin />
      </Content>
    );
  }

  if (session.status === "expired") {
    const copy = expiredCopy(session);
    return (
      <Content style={{ maxWidth: 480, margin: "64px auto", padding: 24 }}>
        <ErrorAlert error={copy.title} description={copy.description} />
      </Content>
    );
  }

  return (
    <Layout style={{ minHeight: "100%", background: "#ffffff" }}>
      <Routes>
        <Route path="/embed/bestill-pose" element={<EmbedBestillPose user={session.user} />} />
        <Route path="*" element={<Navigate to="/embed/bestill-pose" replace />} />
      </Routes>
    </Layout>
  );
}
